const unauthorizedCallbacks: (() => void)[] = [];

export function navigateTo(path: string): void {
  if (typeof window !== 'undefined') {
    window.location.href = path;
  }
}

export function onUnauthorized(cb: () => void): void {
  unauthorizedCallbacks.push(cb);
}

export function triggerUnauthorized(): void {
  for (const cb of unauthorizedCallbacks) cb();
}
